
import BotonWhatsapp from "../components/BotonWhatsapp";

function Servicios() {
  return (
    <div>
      
      
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 mt-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold mb-6">
            Nuestros Servicios en Pujilí
          </h1>
          <p className="text-xl mb-8">
            Internet, seguridad, entretenimiento y soluciones empresariales con instalación gratuita
          </p>
        </div>
      </section>

      {/* Servicios de Internet */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            🌐 Servicios de Internet
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">🏠</div>
              <h3 className="text-xl font-bold mb-4">Internet Residencial</h3>
              <p className="text-gray-600 mb-6">
                Planes desde 400 Mbps para tu hogar. Instalación gratuita y soporte local.
              </p>
              <a 
                href="https://wa.me/593998106377?text=Me interesa internet residencial en Pujilí"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Más Información
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">🎓</div>
              <h3 className="text-xl font-bold mb-4">Internet para Estudiantes</h3>
              <p className="text-gray-600 mb-6">
                Plan especial de 600 Mbps por $17.70. Perfecto para clases online.
              </p>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el plan para estudiantes"
                className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors"
              >
                Más Información
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">🔧</div>
              <h3 className="text-xl font-bold mb-4">Soporte Técnico</h3>
              <p className="text-gray-600 mb-6">
                Técnicos locales en Pujilí. Instalación el mismo día y soporte 24/7.
              </p>
              <a 
                href="tel:0998106377"
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
              >
                Llamar Soporte
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Nuevos Servicios */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            🚀 Servicios Adicionales
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            
            {/* Seguridad Electrónica */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-red-500">
              <div className="text-4xl mb-4">🔒</div>
              <h3 className="text-xl font-bold mb-4">Seguridad Electrónica</h3>
              <div className="text-left mb-4">
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>✓ Cámaras de vigilancia HD/4K</li>
                  <li>✓ Sistemas de alarma inteligentes</li>
                  <li>✓ Monitoreo 24/7</li>
                  <li>✓ Control desde tu móvil</li>
                  <li>✓ Instalación profesional</li>
                </ul>
              </div>
              <p className="text-gray-600 mb-6">
                Protege tu hogar o negocio con tecnología avanzada.
              </p>
              <a 
                href="https://wa.me/593998106377?text=Me interesa información sobre seguridad electrónica"
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
              >
                Cotizar Sistema
              </a>
            </div>

            {/* Fire Stick */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-orange-500">
              <div className="text-4xl mb-4">📺</div>
              <h3 className="text-xl font-bold mb-4">Amazon Fire Stick</h3>
              <div className="text-left mb-4">
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>✓ Netflix, Prime Video, Disney+</li>
                  <li>✓ Control por voz con Alexa</li>
                  <li>✓ Configuración incluida</li>
                  <li>✓ Soporte técnico</li>
                  <li>✓ Garantía extendida</li>
                </ul>
              </div>
              <p className="text-gray-600 mb-6">
                Convierte tu TV en Smart TV con todas las plataformas.
              </p>
              <a 
                href="https://wa.me/593998106377?text=Me interesa comprar Fire Stick"
                className="bg-orange-600 text-white px-6 py-2 rounded-lg hover:bg-orange-700 transition-colors"
              >
                Comprar Ahora
              </a>
            </div>

            {/* Software Contable */}
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow border-t-4 border-purple-500">
              <div className="text-4xl mb-4">📊</div>
              <h3 className="text-xl font-bold mb-4">Software Contable</h3>
              <div className="text-left mb-4">
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>✓ Facturación electrónica</li>
                  <li>✓ Control de inventarios</li>
                  <li>✓ Reportes financieros</li>
                  <li>✓ Capacitación incluida</li>
                  <li>✓ Soporte permanente</li>
                </ul>
              </div>
              <p className="text-gray-600 mb-6">
                Gestiona la contabilidad de tu empresa de forma eficiente.
              </p>
              <a 
                href="https://wa.me/593998106377?text=Me interesa el software contable, solicito demo"
                className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-colors"
              >
                Solicitar Demo
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Contacto */}
      <section className="py-16 bg-gradient-to-r from-gray-800 to-gray-900 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Necesitas más información?</h2>
          <p className="text-xl mb-8 opacity-90">
            Nuestro equipo está listo para asesorarte en Pujilí
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-lg">
            <div className="flex items-center gap-3">
              <span className="text-2xl">📞</span>
              <span>099-810-6377</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl">📧</span>
              <span>hightelecom2025@gmail.com</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl">📍</span>
              <span>Pujilí, Cotopaxi</span>
            </div>
          </div>
        </div>
      </section>

      <BotonWhatsapp />
    </div>
  );
}

export default Servicios;